/**
 * main.js
 * @description Module assignment
 */


import WindowEvents from './app/WindowEvents';

import $ from 'jquery';

import './app/HeaderNavigation/HeaderNavigationComponent';
import HeaderNavigation from './app/HeaderNavigation/HeaderNavigation';
import CloseButton from './app/HeaderNavigation/CloseButton';
import Dropdown from './app/HeaderNavigation/Dropdown';
import Menu from './app/HeaderNavigation/Menu';
import Title from './app/HeaderNavigation/Title';

import SearchPanel from './app/Search/SearchPanel';
import SearchButtons from './app/Search/SearchButtons';

import ImageGallery from './app/Gallery/ImageGallery';

import Alerts from './app/Alerts/Alerts'

import Events from './app/Events';

import './app/HeaderNavigation/Logo';

import './app/AnchorScroll';

import './vendor/picturefill';

import './app/MagnificPopup/MagnificPopup';

import './app/SocialSharing';

import './app/Search/FacetAccordion';
import './app/ExploreHover';
import './app/ImageLoading';
import './app/MiniLogo';
import './app/Modal';
import './app/PageBlog/PageBlog';
import './app/NewsletterModal';

(function(window) {

	// namespace
	window.uo = {};


	window.uo.events = new Events();
	// document ready event listener
	window.addEventListener('DOMContentLoaded', () => {

    // namespaced class instantiations
		window.uo.headerNavigation = new HeaderNavigation({
			id: 'header-bar-navigation',
			buttonClassName: 'header-bar-navigation__link--button',
			dropdownId: 'taxonomy-dropdown',
			Dropdown: Dropdown,
			Menu: Menu,
			Title: Title,
			CloseButton: CloseButton,
			events: window.uo.events
		});

		window.uo.searchPanel = new SearchPanel({
			id: 'search-dropdown'
		});

		// block-scoped classes that don't need to be in the namespace
		(function() {
			new SearchButtons({
				className: 'toggle-search-button',
				panel: window.uo.searchPanel,
				events: window.uo.events
			});
		})();

		(function() {
			if ($('.content-block--gallery').length > 0) {
				$('.content-block--gallery').each(function() {
					new ImageGallery($(this), $(this).data('index'));
				});
			}
		})();

		(function() {
			if ($('.comments').length > 0) {

				$('#comment-row').insertBefore($('#comment-message'));

				$('#comment-button').on('click', () => {
					$('.comments-form').fadeIn(200);
					$('#comment-button').hide();
				});
			}
		})();

		(function() {
			if ($('.alert-box').length > 0) {
				new Alerts({
					boxClassName: 'alert-box',
					closeButtonClass: 'alert-close-button'
				});
			}
		})();


	});

})(window);
